export default __webpack_public_path__ + "assets/images/Payment_07.8ed736.webp";